<script setup lang="ts">
import type { PinInputInputProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { PinInputInput, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

const props = defineProps<PinInputInputProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <PinInputInput
    v-bind="forwardedProps"
    :class="cn(
      'ds-control flex h-13 w-full items-center justify-center rounded-ds-md border border-input bg-card text-center font-ds text-xl font-bold text-foreground outline-none transition-[border-color,box-shadow] duration-ds-fast ease-ds-standard focus-visible:border-ring focus-visible:shadow-ds-focus disabled:cursor-not-allowed disabled:bg-muted',
      props.class,
    )"
  />
</template>
